function initRelatedProductsSwiper() {
//   Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper library not loaded yet');
    return;
  }

  const relatedSections = document.querySelectorAll('[data-related-products-section]');

  relatedSections.forEach((section) => {
    // Skip if already initialized
    if (section.swiperInstance || section.hasAttribute('data-swiper-initialized')) {
      return;
    }

    const swiperWrapper = section.querySelector('.custom-related-products-swiper');
    if (!swiperWrapper || swiperWrapper.hasAttribute('data-swiper-initialized')) {
      return;
    }

    const swiperContainer = swiperWrapper.querySelector('.swiper');
    const slides = swiperWrapper.querySelectorAll('.swiper-slide');

    if (swiperContainer && slides.length > 0) {
      const maxProducts = parseInt(swiperWrapper.getAttribute('data-max-products')) || 3;
      const productsCount = parseInt(swiperWrapper.getAttribute('data-products-count')) || slides.length;
      
      // Center slides when number of slides matches max_products setting
      const shouldCenter = productsCount === maxProducts;
      
      try {
        const swiper = new Swiper(swiperContainer, {
          spaceBetween: 20,
          centeredSlides: shouldCenter,
          centeredSlidesBounds: shouldCenter, // Prevent partial slides when centered
          loop: false,
          resistanceRatio: 0,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,
          allowTouchMove: true,
          navigation: { enabled: false },
          pagination: { enabled: false },
          scrollbar: {
            el: swiperWrapper.querySelector('.swiper-scrollbar'),
            draggable: productsCount > maxProducts, // Only draggable if there are more slides
            dragSize: 'auto',
            hide: productsCount <= maxProducts, // Hide scrollbar when all slides are visible
          },
          breakpoints: {
            0: {
              slidesPerView: 'auto',
              freeMode: { enabled: true, sticky: true },
              centeredSlides: false,
              centeredSlidesBounds: false,
            },
            750: {
              slidesPerView: 'auto',
              freeMode: { enabled: false },
              centeredSlides: shouldCenter,
              centeredSlidesBounds: shouldCenter,
            },
            1430: {
              slidesPerView: maxProducts,
              freeMode: { enabled: false },
              centeredSlides: shouldCenter,
              centeredSlidesBounds: shouldCenter,
            }
          }
        });

        section.swiperInstance = swiper;
        section.setAttribute('data-swiper-initialized', 'true');
        swiperWrapper.setAttribute('data-swiper-initialized', 'true');
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelatedProductsSwiper);
} else {
  initRelatedProductsSwiper();
}

// Re-initialize when content is dynamically loaded (for data-island)
document.addEventListener('shopify:section:load', initRelatedProductsSwiper);

// Also listen for mutations in case content loads via other means (with debounce)
let mutationTimeout;
const observer = new MutationObserver(function(mutations) {
  clearTimeout(mutationTimeout);
  mutationTimeout = setTimeout(function() {
    const hasRelatedProducts = document.querySelector('[data-related-products-section] .custom-related-products-swiper:not([data-swiper-initialized])');
    if (hasRelatedProducts && typeof Swiper !== 'undefined') {
      initRelatedProductsSwiper();
    }
  }, 100);
});

if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Also try to initialize after a short delay to catch any late-loading content
setTimeout(initRelatedProductsSwiper, 500);


